// Maak het compleet: het totaal volgt de aangevinkte producten. Het toevoegen zelf doet theme.js (formulier naar /cart/add).

function moneyFormatter(sample) {
  // Het voorbeeld is 123456 centen in het geldformaat van de winkel, bijvoorbeeld "€1.234,56".
  const match = /^(.*?)1(\D?)234(?:(\D)56)?(.*)$/.exec(sample || '');
  if (!match) return (cents) => (cents / 100).toFixed(2);
  const [, prefix, thousands, decimal, suffix] = match;
  return (cents) => {
    const whole = decimal ? Math.floor(cents / 100) : Math.round(cents / 100);
    const grouped = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const fraction = decimal ? decimal + String(cents % 100).padStart(2, '0') : '';
    return `${prefix}${grouped}${fraction}${suffix}`;
  };
}

class CompleteSet extends HTMLElement {
  connectedCallback() {
    this.format = moneyFormatter(this.dataset.moneySample);
    this.total = this.querySelector('[data-total]');
    this.addEventListener('change', () => this.update());
  }

  update() {
    let cents = Number(this.querySelector('.cset__price[data-price]')?.dataset.price || 0);
    this.querySelectorAll('input[type="checkbox"][data-price]').forEach((box) => {
      if (box.checked) cents += Number(box.dataset.price);
    });
    if (this.total) this.total.textContent = this.format(cents);
  }
}

if (!customElements.get('complete-set')) customElements.define('complete-set', CompleteSet);
